import React, { useState } from 'react';

function ProfileNameForm({ initialName = '', onSave, onCancel }) {
  const [name, setName] = useState(initialName);
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedName = name.trim();
    if (!trimmedName) {
      setErrorMessage('Please enter a name.');
      return;
    }

    setErrorMessage('');
    setIsSaving(true);

    try {
      await onSave(trimmedName);
      onCancel();
    } catch (error) {
      setErrorMessage(error.message || 'Failed to update name');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div
        className="modal profile-name-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="profile-name-title"
      >
        <div className="modal-header">
          <h2 className="modal-title" id="profile-name-title">
            Update Display Name
          </h2>
          <button type="button" className="modal-close" onClick={onCancel} aria-label="Close">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="profile-name-input" className="form-label">
              Display name
            </label>
            <input
              id="profile-name-input"
              type="text"
              className="form-control"
              value={name}
              onChange={(event) => {
                setErrorMessage('');
                setName(event.target.value);
              }}
              placeholder="Enter your custom name"
              required
              autoFocus
            />
          </div>

          {errorMessage && (
            <div className="form-status-message error" role="alert">
              {errorMessage}
            </div>
          )}

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save Name'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProfileNameForm;
